module.exports = __webpack_public_path__ + "img/PL08721.7738b377.png";